import { AudioFeatureType } from "../../api/cc-smarts/models/AudioFeature";

export const getAIFeatureName = (type: AudioFeatureType): string => {
	switch (type) {
		case AudioFeatureType.BRIEFING:
			return 'aiBriefingAudioPlayer';
		case AudioFeatureType.NARRATION:
			return 'aiNarrationAudioPlayer';
	}
};
